import clsx from "clsx";
import { useForm } from "react-hook-form";
import { useUser } from "../store";

export default function Login() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const { login } = useUser();

  const onSubmit = async ({ username, password }) => {
    login(username, password);
  };

  return (
    <form className="auth-page auth-card" onSubmit={handleSubmit(onSubmit)}>
      <h1 className="title">Login</h1>
      <p className="auth-description">
        Sign in to manage aging reports and payer follow-up.
      </p>
      <div className="field">
        <label className="label">Username</label>
        <div className="control has-icons-left">
          <input
            {...register("username", { required: "Username is required" })}
            className={clsx("input", {
              "is-danger": errors?.username,
            })}
            type="text"
            autoComplete="username"
            placeholder="Username"
          />
          <span className="icon is-small is-left">
            <i className="fas fa-user" aria-hidden="true"></i>
          </span>
        </div>
        <p className="help is-danger">{errors?.username?.message}</p>
      </div>
      <div className="field">
        <label className="label">Password</label>
        <div className="control has-icons-left">
          <input
            {...register("password", { required: "Password is required" })}
            className={clsx("input", {
              "is-danger": errors?.password,
            })}
            type="password"
            autoComplete="current-password"
            placeholder="Password"
          />
          <span className="icon is-small is-left">
            <i className="fas fa-lock" aria-hidden="true"></i>
          </span>
        </div>
        <p className="help is-danger">{errors?.password?.message}</p>
      </div>
      <div className="field">
        <div className="control">
          <button className="button auth-submit">Sign in</button>
        </div>
      </div>
    </form>
  );
}
